export function isScreenWidthGreaterThan(number) {
  return window.innerWidth > number;
}
